import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, createTheme } from '@mui/material';
import Navbar from './components/common/nav/Navbar.tsx';
import Modal from './components/common/Modal.tsx';
import Home from './pages/Home.tsx';
import AllServices from './pages/AllServices.tsx';
import Locations from './pages/Locations.tsx';
import ContactUs from './pages/ContactUs.tsx';
import Footer from './components/common/Footer.tsx';
import DropOffMenu from './pages/DropOffMenu.tsx';

const App: React.FC = () => {

  const theme = useMemo(
    () =>
      createTheme({
        breakpoints: {
          values: {
            xs: 0,
            sm: 976,
            md: 1000,
            lg: 1280,
            xl: 1920
          },
        },
        palette: {
          mode: "light",
          ...({
              primary: {
                main: "#1E325A",
              },
              background: {
                default: "#A0C8F0",
                paper: "#B0D4F5",
              },
              text: {
                primary: "#000",
                secondary: "#1C3F72",
              },
            }),
        },
        typography: {
          fontFamily: '"Lora", serif',
          allVariants: {
            color: "#000", // Global font color for navbar text
          },
        },
      }),
    []
  );

  
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <Box
          sx={{
            minHeight: 'fit-content',
            backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.background.paper})`,
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            pt: 8,
            paddingTop: '56px',
          }}
        >
          <Modal />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/all-services" element={<AllServices />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/menu-dropoff" element={<DropOffMenu />} />
          </Routes>
        </Box>
        <Footer />
      </ThemeProvider>
    </Router>
  );
};

export default App;